// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"cbb7cb0e84bc4c92770e","180":"a1b91a062a8d419b7a51"}[chunkId] + ".css";
};